import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const jobOrientedSkillApi = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'jobOrientedSkillApi',
    endpoints: (builder) => ({

        getListJobOrientedSkill: builder.query({
            query: () => ({
                url: '/job-skills',
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getJobOrientedSkillById: builder.query({
            query: (id) => ({
                url: `/job-skills/${id}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Body: { skillNames: ["Spring Mongo", ...] }
        addJobOrientedSkill: builder.mutation({
            query: (data) => ({
                url: '/job-skills/add',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        // Body: { id: 47, skillName: "Spring Boot Mongo" }
        updateJobOrientedSkill: builder.mutation({
            query: (data) => ({
                url: '/job-skills/update',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteJobOrientedSkill: builder.mutation({
            query: (id) => ({
                url: `/job-skills/${id}`,
                method: 'DELETE'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useLazyGetListJobOrientedSkillQuery, useLazyGetJobOrientedSkillByIdQuery,
    useAddJobOrientedSkillMutation, useUpdateJobOrientedSkillMutation,
    useDeleteJobOrientedSkillMutation
} = jobOrientedSkillApi;

export default jobOrientedSkillApi;
